import { data } from '../../svg/Document/data';
import { makeIcon } from '../makeIcon';

export const Document = makeIcon(data, 'document', 'Document');

export default Document;
